import axios from 'axios';
import { getPosthogSessionInfo } from '@elementary/common-ui/hooks/tracking/usePosthogSessionInfo';

let requestInterceptor: number;

export const axiosInterceptors = (accessToken: string) => {
  if (requestInterceptor !== undefined) {
    axios.interceptors.request.eject(requestInterceptor);
  }

  requestInterceptor = axios.interceptors.request.use(async (config) => {
    const requestConfig = config;

    requestConfig.responseType = 'json';

    if (accessToken) {
      requestConfig.headers.Authorization = `Bearer ${accessToken}`;
    }

    // Add PostHog session info to headers
    const { sessionId, sessionUrl } = getPosthogSessionInfo();
    if (sessionId) {
      requestConfig.headers['X-PostHog-Session-ID'] = sessionId;
    }
    if (sessionUrl) {
      requestConfig.headers['X-PostHog-Session-URL'] = sessionUrl;
    }

    return requestConfig;
  });
};
